// extracted by mini-css-extract-plugin
export default {"okButton":"okButton___J9iua","cancelButton":"cancelButton___WEv5K"};